module.exports = __webpack_public_path__ + "static/img/icon-e.861158a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-e.png
// module id = D02e
// module chunks = 1